import { SortDirection } from 'bold-ui'
import { Sort } from 'graphql/types.generated'

export function convertSortDirectionToSort(sortDirection: SortDirection): Sort {
  if (sortDirection === 'ASC') {
    return Sort.ASC
  }

  return Sort.DESC
}
